import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-discapacidades',
  templateUrl: './discapacidades.component.html',
  styleUrls: ['./discapacidades.component.css']
})
export class DiscapacidadesComponent implements OnInit {

	@Input() tipos
	@Input() grados
	@Input() causas
	@Input() personaID = 1
	@Input() discapacidadesIncoming
	@Input() noEditable =  false
	@Output() onChange = new EventEmitter<object>();
	discapacidades = [

	]

	constructor() {

	}

  	ngOnInit(): void {

	}

	ngOnChanges(changes):void {
		this.discapacidades = this.tipos.map((tipo, i) => {
			return({TipoID: tipo.ID, GradoID: 0 , CausaID: 0, Codigo: tipo.Codigo})
		})
		this.setDiscapacidades()
	}

	setDiscapacidades() {
		this.discapacidades = this.discapacidades.map(discapacidad => {
			const filter:Array<any> = this.discapacidadesIncoming.filter(value => {

				if(value.TipoID === discapacidad.TipoID) {
					return true
				} else {
					return false
				}
			})
			if(filter.length > 0) {
				const obj = discapacidad
				obj.GradoID = filter[0].GradoID
				obj.CausaID = filter[0].CausaID
				return obj
			} else {
				return discapacidad
			}
		})

	}

	asignarGrado(e,grado,tipo): void {
		this.discapacidades.forEach(discapacidad => {
			if(discapacidad.Codigo === tipo.Codigo ) {
				discapacidad.GradoID = grado
			}
		})
		this.emit()
	}
	asignarCausa (e,tipo,causa) {
		this.discapacidades.forEach(discapacidad => {
			if(discapacidad.TipoID === tipo.ID ) {
				discapacidad.CausaID = causa
			}
		})
		this.emit()
	}
	emit () {
		const emicionDiscapacitados = this.discapacidades.filter(discapacidad => {
			if(discapacidad.GradoID === undefined && discapacidad.CausaID === 0 ) {
				return false
			}else {
				return true
			}
		})
		console.log(emicionDiscapacitados)
		this.onChange.emit(emicionDiscapacitados)
	}



}
